module.exports = __webpack_public_path__ + "static/media/progress-hollow.65aee79b.svg";